import {
  Card,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  useTheme,
} from "@mui/material";
import { useMemo } from "react";
import { formatTime } from "@pages/OrderTracker/components/PlanningAutomation/Timer";
import type { ConsumerInfoOut } from "@providers/hop-ord-server/api";

interface ConsumerTableProps {
  consumers: ConsumerInfoOut[];
}

export const ConsumerTable = ({ consumers }: ConsumerTableProps) => {
  const theme = useTheme();

  const sortedConsumers = useMemo(
    () =>
      consumers.sort((a, b) =>
        (a.consumerName || "").localeCompare(b.consumerName || ""),
      ),
    [consumers],
  );

  return (
    <Card>
      <TableContainer
        sx={{
          maxHeight: "400px",
          overflow: "auto",
        }}
      >
        <Table
          stickyHeader
          size="small"
          sx={{
            "& .MuiTableCell-head": { padding: 2 },
            "& .MuiTableCell-body": {
              padding: 1,
              borderRight: `1px solid ${theme.palette.divider}`,
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>Consumer Name</TableCell>
              <TableCell align="right">Idle Time</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedConsumers.map((consumer, index) => (
              <TableRow key={`${consumer.consumerName || "unknown"}-${index}`}>
                <TableCell>{consumer.consumerName || "Unknown"}</TableCell>
                <TableCell align="right">
                  {formatTime(Math.floor(consumer.idleTime / 1000))}
                </TableCell>
                <TableCell align="center">
                  <Chip label="Idle" color="default" size="small" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};
